const ALLOWLIST_URL = '/mitra-me/allowlists/';

export const getAllowlist = ($axios, type) => $axios.$get(`${ALLOWLIST_URL}${type}`);
